import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    clientname: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a phone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    eventextra6: {
      validations: []
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of guests' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please select an option' }
      ]
    },
    accountextra1: {
      validations: []
    },
    eventextra7: {
      validations: [
        { type: 'required', message: 'Please enter your Venue name' }
      ]
    },
     notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name*',
            mapping: 'lastName'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Organization',
            mapping: 'clientname'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone*',
            mapping: 'telnumber'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Email*',
            mapping: 'email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event*',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Is Your Date Flexible? If YES, what other dates are your considering? (MM/DD/YYYY)',
            mapping: 'eventextra6'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests*',
            mapping: 'plannedguestcount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'Type of Event*',
            options: [
              { label: 'Wedding Reception', value: 'Wedding Reception'},
              { label: 'Bat/Bar Mitzvah', value: 'Bat/Bar Mitzvah' },
              { label: 'Corporate Event', value: 'Corporate Event' },
              { label: 'Fashion Show', value: 'Fashion Show' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Funeral', value: 'Funeral' },
              { label: 'Gala', value: 'Gala' },
              { label: 'Grand Opening', value: 'Grand Opening' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Happy Hour', value: 'Happy Hour' },
              { label: 'Meeting/Seminar', value: 'Meeting/Seminar' },
              { label: 'Open House', value: 'Open House' },
              { label: 'Picnic', value: 'Picnic' },
              { label: 'Prom', value: 'Prom' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Reunion', value: 'Reunion' },
              { label: 'Social Event', value: 'Social Event' },
              { label: 'Concert', value: 'Concert' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'XLarge',
            label: 'How did you hear about us?',
            options: [
              { label: 'Online Search', value: 'Online Search'},
              { label: 'Attended an Event', value: 'Attended an Event' },
              { label: 'Crave Restaurants', value: 'Crave Restaurants' },
              { label: 'Referred by Friend/Colleague', value: 'Referred by Friend/Colleague' },
              { label: 'Referred by my Venue', value: 'Referred by my Venue' },
              { label: 'Repeat Client', value: 'Repeat Client' },
              { label: 'Bridal Show', value: 'Bridal Show' },
              { label: 'Print Publication', value: 'Print Publication' },
              { label: 'Social Media', value: 'Social Media' },
              { label: 'Email', value: 'Email' },
              { label: 'The Knot', value: 'The Knot' }
            ],
            mapping: 'accountextra1'
          }
        ]
      },
      
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Where are you planning your event?*',
            mapping: 'eventextra7'
          }
        ]
      },

      {
        fields: [
          {
            type: 'text-area',
            size: 'XLarge',
            label: 'Anything else you would like to tell us about your event?',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'SUBMIT'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Crave Catering Contact Form',
    formId: '289',
    clientKey: '25DDEE15-C18D-47B8-8E92-0A2311F4168A',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your message has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// c:/_Development/Web Inquiry/inquiry-renderer/client_forms/crave1/form_structure.js